function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "left"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15,85C-4.3,65.7-4.3,34.3,15,15l35,35L15,85z"
}), /*#__PURE__*/React.createElement("rect", {
  y: 42.6,
  className: "st1",
  width: 22.7,
  height: 14.8
}), /*#__PURE__*/React.createElement("text", {
  id: "left-label",
  transform: "matrix(1 0 0 1 4.6743 56.7932)",
  className: "st2 st3"
}, "D"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "bottom"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M85,85c-19.3,19.3-50.7,19.3-70,0l35-35L85,85z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 38.7,
  y: 81.5,
  className: "st1",
  width: 22.7,
  height: 17
}), /*#__PURE__*/React.createElement("text", {
  id: "bottom-label",
  transform: "matrix(1 0 0 1 43.34 95.7451)",
  className: "st2 st3"
}, "D"));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "right"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M85,15c19.3,19.3,19.3,50.7,0,70L50,50L85,15z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 77.3,
  y: 42.6,
  className: "st1",
  width: 22.7,
  height: 14.8
}), /*#__PURE__*/React.createElement("text", {
  id: "right-label",
  transform: "matrix(1 0 0 1 82.0057 56.7932)",
  className: "st2 st3"
}, "D"));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "top"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M15,15C34.3-4.3,65.7-4.3,85,15L50,50L15,15z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 38.7,
  y: 4,
  className: "st1",
  width: 22.7,
  height: 17
}), /*#__PURE__*/React.createElement("text", {
  id: "top-label",
  transform: "matrix(1 0 0 1 43.34 18.2004)",
  className: "st2 st3"
}, "D"));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "center"
}, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 50,
  cy: 50,
  r: 28
}), /*#__PURE__*/React.createElement("rect", {
  x: 22,
  y: 22,
  className: "st1",
  width: 56,
  height: 56
}), /*#__PURE__*/React.createElement("text", {
  id: "center-label",
  transform: "matrix(1 0 0 1 49 62)",
  className: "st2 st4"
}, "99"));

var SvgTable = function SvgTable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "table-svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/table.baef5d79.svg";
export { ForwardRef as ReactComponent };